<template>
  <div
    class="rounded"
    :class="[`aha-info--${variant}`]"
  >
    <div class="inline-flex p-2">
      <aha-icon
        name="information"
        class="flex-shrink-0 mr-1"
        :class="[`aha-info-icon--${variant}`]"
      />
      <span class="text-xs text-base-90">
        <slot />
      </span>
    </div>
  </div>
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-info--primary {
  @apply bg-primary-40;
}
.aha-info--error {
  @apply bg-yellow-10;
}

.aha-info-icon--primary {
  @apply text-primary-90;
}
.aha-info-icon--error {
  @apply text-yellow-50;
}
</style>
